<template>
  <section>
    <v-layout row wrap>
      <v-flex xs12 md4>
        <v-text-field
          v-model="filtros.folio"
          label="Folio"
          outlined
          placeholder="INTRODUZCA Folio"
          @keyup.enter="buscarFolio"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md2>
        <v-btn
          color="primary"
          @click="buscarFolio"
          class="mt-2"
        >
          BUSCAR
        </v-btn>
      </v-flex>
      <!--
      <v-flex xs12 md4 offset-md1>
        <v-text-field
          v-model="filtros.filtro"
          label="FILTRAR"
          outlined
          placeholder="FILTRAR POR"
          @input="filtrarDatos"
        ></v-text-field>
      </v-flex>
      -->
    </v-layout>

    <v-layout row class="mt-4">
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-data-table
              :items="muestras"
              :items-per-page="15"
              :search="filtros.filtro"
              class="elevation-1"
              :height="$vuetify.breakpoint.height * 0.65 + 'px'"
            >
              <template v-slot:header>
                <thead>
                  <tr>
                    <th rowspan="2" class="text-center" style="min-width: 300px">Folio</th>
                    <th rowspan="2" class="text-center" style="min-width: 250px">Paciente</th>
                    <th rowspan="2" class="text-center" style="min-width: 180px">Fecha Toma</th>
                    <th rowspan="2" class="text-center" style="min-width: 120px">Edad</th>
                    <th rowspan="2" class="text-center" style="min-width: 120px">Genero</th>
                    <th rowspan="2" class="text-center" style="min-width: 200px">Motivo de Prueba</th>
                    <th colspan="3" class="text-center">rs2052129</th>
                    <th colspan="3" class="text-center">rs10156191</th>
                    <th colspan="3" class="text-center">rs1049742</th>
                    <th colspan="3" class="text-center">rs1049793</th>
                    <th rowspan="2" class="text-center" style="min-width: 150px">No. de mutaciones detectadas</th>
                    <th rowspan="2" class="text-center" style="min-width: 380px">Interpretación</th>
                    <th rowspan="2" class="text-center" style="min-width: 120px">Visualizar</th>
                    <th rowspan="2" class="text-center" style="min-width: 100px">Validación</th>
                  </tr>
                  <tr class="subheader-row">
                    <th class="text-center" style="min-width: 170px">Resultado</th>
                    <th class="text-center" style="min-width: 120px">Bases</th>
                    <th class="text-center" style="min-width: 150px">Interpretación</th>
                    <th class="text-center" style="min-width: 170px">Resultado</th>
                    <th class="text-center" style="min-width: 120px">Bases</th>
                    <th class="text-center" style="min-width: 150px">Interpretación</th>
                    <th class="text-center" style="min-width: 170px">Resultado</th>
                    <th class="text-center" style="min-width: 120px">Bases</th>
                    <th class="text-center" style="min-width: 150px">Interpretación</th>
                    <th class="text-center" style="min-width: 170px">Resultado</th>
                    <th class="text-center" style="min-width: 120px">Bases</th>
                    <th class="text-center" style="min-width: 150px">Interpretación</th>
                  </tr>
                </thead>
              </template>
              <template v-slot:item="props">
                <tr>
                  <td class="text-center">{{ props.item.transaction_id }}</td>
                  <td class="text-center">{{ props.item.Paciente }}</td>
                  <td class="text-center">{{ props.item.FechaMuestra }}</td>
                  <td class="text-center">{{ props.item.Edad }}</td>
                  <td class="text-center">{{ props.item.Genero }}</td>
                  <td class="text-center">{{ props.item.Causa }}</td>
                  <td class="text-center">
                    <v-select
                      v-model="props.item.rs2052129_resultado"
                      :items="resultadoOptions"
                      dense
                      outlined
                      hide-details
                      @change="actualizarCampo(props.item, 'rs2052129_resultado')"
                    ></v-select>
                  </td>
                  <td class="text-center">{{ props.item.rs2052129_bases }}</td>
                  <td class="text-center">{{ props.item.rs2052129_interpretacion }}</td>
                  <td class="text-center">
                    <v-select
                      v-model="props.item.rs10156191_resultado"
                      :items="resultadoOptions"
                      dense
                      outlined
                      hide-details
                      @change="actualizarCampo(props.item, 'rs10156191_resultado')"
                    ></v-select>
                  </td>
                  <td class="text-center">{{ props.item.rs10156191_bases }}</td>
                  <td class="text-center">{{ props.item.rs10156191_interpretacion }}</td>
                  <td class="text-center">
                    <v-select
                      v-model="props.item.rs1049742_resultado"
                      :items="resultadoOptions"
                      dense
                      outlined
                      hide-details
                      @change="actualizarCampo(props.item, 'rs1049742_resultado')"
                    ></v-select>
                  </td>
                  <td class="text-center">{{ props.item.rs1049742_bases }}</td>
                  <td class="text-center">{{ props.item.rs1049742_interpretacion }}</td>
                  <td class="text-center">
                    <v-select
                      v-model="props.item.rs1049793_resultado"
                      :items="resultadoOptions"
                      dense
                      outlined
                      hide-details
                      @change="actualizarCampo(props.item, 'rs1049793_resultado')"
                    ></v-select>
                  </td>
                  <td class="text-center">{{ props.item.rs1049793_bases }}</td>
                  <td class="text-center">{{ props.item.rs1049793_interpretacion }}</td>
                  <td class="text-center">{{ getMutationCount(props.item) }}</td>
                  <td class="text-center">{{ getInterpretation(props.item) }}</td>
                  <td class="text-center">
                    <v-icon
                      :color="puedeVisualizar(props.item) ? 'primary' : 'grey lighten-1'"
                      :class="['preview-icon', { 'preview-icon--disabled': !puedeVisualizar(props.item) }]"
                      @click.prevent="puedeVisualizar(props.item) && visualizarReporte(props.item)"
                    >
                      mdi-eye
                    </v-icon>
                  </td>
                  <td class="text-center">
                    <v-btn
                      icon
                      @click.prevent="(e) => toggleValidation(props.item, e)"
                      :color="props.item.Validado ? 'success' : 'grey'"
                    >
                      <v-icon>{{ props.item.Validado ? 'check_circle' : 'radio_button_unchecked' }}</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template v-slot:no-data>
                No hay datos para mostrar
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import ServicioLaboratorioDAO from '@/services/laboratoriodao';

export default {
  name: 'LaboratorioDAO',
  watch: {
    'muestras': {
      deep: true,
      handler(newMuestras) {
        newMuestras.forEach(muestra => {
          // rs2052129
          if (muestra.rs2052129_resultado === 'VIC/VIC') {
            muestra.rs2052129_bases = 'G/G';
            muestra.rs2052129_interpretacion = 'Sin mutación';
          }
          if (muestra.rs2052129_resultado === 'FAM/VIC') {
            muestra.rs2052129_bases = 'G/T';
            muestra.rs2052129_interpretacion = 'Mutación detectada';
          }
          if (muestra.rs2052129_resultado === 'FAM/FAM') {
            muestra.rs2052129_bases = 'T/T';
            muestra.rs2052129_interpretacion = 'Mutación detectada';
          }

          // rs10156191
          if (muestra.rs10156191_resultado === 'VIC/VIC') {
            muestra.rs10156191_bases = 'C/C';
            muestra.rs10156191_interpretacion = 'Sin mutación';
          }
          if (muestra.rs10156191_resultado === 'FAM/VIC') {
            muestra.rs10156191_bases = 'C/T';
            muestra.rs10156191_interpretacion = 'Mutación detectada';
          }
          if (muestra.rs10156191_resultado === 'FAM/FAM') {
            muestra.rs10156191_bases = 'T/T';
            muestra.rs10156191_interpretacion = 'Mutación detectada';
          }

          // rs1049742
          if (muestra.rs1049742_resultado === 'VIC/VIC') {
            muestra.rs1049742_bases = 'C/C';
            muestra.rs1049742_interpretacion = 'Sin mutación';
          }
          if (muestra.rs1049742_resultado === 'FAM/VIC') {
            muestra.rs1049742_bases = 'C/T';
            muestra.rs1049742_interpretacion = 'Mutación detectada';
          }
          if (muestra.rs1049742_resultado === 'FAM/FAM') {
            muestra.rs1049742_bases = 'T/T';
            muestra.rs1049742_interpretacion = 'Mutación detectada';
          }

          // rs1049793
          if (muestra.rs1049793_resultado === 'VIC/VIC') {
            muestra.rs1049793_bases = 'C/C';
            muestra.rs1049793_interpretacion = 'Sin mutación';
          }
          if (muestra.rs1049793_resultado === 'FAM/VIC') {
            muestra.rs1049793_bases = 'C/G';
            muestra.rs1049793_interpretacion = 'Mutación detectada';
          }
          if (muestra.rs1049793_resultado === 'FAM/FAM') {
            muestra.rs1049793_bases = 'G/G';
            muestra.rs1049793_interpretacion = 'Mutación detectada';
          }
        });
      }
    }
  },
  data() {
    return {
      muestras: [],
      filtros: {
        folio: '',
        filtro: ''
      },
      resultadoOptions: [
        'FAM/FAM',
        'FAM/VIC',
        'VIC/VIC'
      ]
    };
  },
  created() {
    this.cargarDatos();
  },
  methods: {
    async cargarDatos() {
      try {
        const response = await ServicioLaboratorioDAO.reporte();
        if (response.data && response.data.result === 1 && response.data.tables > 0 && response.data.data && response.data.data.Table0) {
          this.muestras = response.data.data.Table0;
        } else {
          console.error('Formato de respuesta inválido:', response);
          this.$toast.error('Error en el formato de los datos recibidos');
          this.muestras = [];
        }
      } catch (error) {
        console.error('Error al cargar los datos:', error);
        this.$toast.error('Error al cargar los datos');
        this.muestras = [];
      }
    },
    async buscarFolio() {
      //if (!this.filtros.folio) return;
      
      try {
        this.loading = true;
        const response = await ServicioLaboratorioDAO.reporte({
          transaction_id: this.filtros.folio
        });
        
        if (response.data && response.data.result === 1 && response.data.tables > 0 && response.data.data && response.data.data.Table0) {
          this.muestras = response.data.data.Table0;
          if (this.muestras.length === 0) {
            this.$toast.info('No se encontraron resultados');
          }
        } else {
          console.error('Formato de respuesta inválido:', response);
          this.$toast.error('Error en el formato de los datos recibidos');
          this.muestras = [];
        }
        
        this.filtros.folio = ''; // Clear the folio input field
      } catch (error) {
        console.error('Error al buscar folio:', error);
        this.$toast.error('Error al buscar el folio');
        this.muestras = [];
      } finally {
        this.loading = false;
      }
    },
    filtrarDatos() {
      // The v-data-table handles filtering automatically through the :search prop
       // La búsqueda se maneja automáticamente por v-data-table
        console.log("Filtrando datos:", this.filtros.filtro);
    },
    getMutationCount(item) {
      let count = 0;
      if (item.rs2052129_interpretacion === 'Mutación detectada') count++;
      if (item.rs10156191_interpretacion === 'Mutación detectada') count++;
      if (item.rs1049742_interpretacion === 'Mutación detectada') count++;
      if (item.rs1049793_interpretacion === 'Mutación detectada') count++;
      return count;
    },
    getInterpretation(item) {
      const mutationCount = this.getMutationCount(item);
      return mutationCount === 0
        ? 'No presenta predisposición genética a déficit de DAO'
        : 'Presenta predisposición genética a déficit de DAO';
    },
    toggleValidation(item, event) {
      // Check if the click was on the icon or its parent button
      const isValidationClick = event && (event.target.closest('button') || event.target.closest('.v-icon'));
      if (isValidationClick) {
        // Check if all result fields are filled
        if (!item.rs2052129_resultado || !item.rs10156191_resultado || 
            !item.rs1049742_resultado || !item.rs1049793_resultado ) {
          //this.$toast.error('Todos los campos de resultado deben estar seleccionados antes de validar');
          this.$root.mensajeAviso = 'Todos los campos de resultado deben estar seleccionados antes de validar';
          return;
        }

        const perfil = localStorage.getItem("perfil");
        if (perfil !== "Administrador DAO" && perfil !== "QA DAO" ) {
          this.$root.mensajeAviso = 'Solo el QA puede confirmar la validación';
          return;
        }

        this.$root.$emit('mostrarConfirmar', {
          titulo: 'Confirmar Validación',
          mensaje: '¿Está seguro de cambiar el estado de validación?',
          resolve: () => {
            // Remove setting Validado=true here, we'll set it after API success
            //item.Validado = true;
            this.validacionQA(item);
          },
          reject: () => {
            // Do nothing if rejected
          }
        });
      }
    },
    
    async actualizarCampo(item, campo) {
      try {
        const datos = {
          id: item.id,
          transaction_id: item.transaction_id,
          campo: campo,
          valor: item[campo]
        };
        
        const response = await ServicioLaboratorioDAO.actualizarCampo(datos);
        if (response.data && response.data.result === 1) {
          //this.$toast.success('Campo actualizado correctamente');
          console.log('Error al actualizar campo:', response);
        } else {
          console.error('Error al actualizar campo:', response);
          //this.$toast.error('Error al actualizar el campo');
        }
      } catch (error) {
        console.error('Error en la petición:', error);
        //this.$toast.error('Error en la petición al servidor');
      }
    },

    async validacionQA(item) {
      try {

        const registroCompleto = {
          id: item.id,
          transaction_id: item.transaction_id,
          rs2052129_resultado: item.rs2052129_resultado,
          rs2052129_bases: item.rs2052129_bases,
          rs2052129_interpretacion: item.rs2052129_interpretacion,
          rs10156191_resultado: item.rs10156191_resultado,
          rs10156191_bases: item.rs10156191_bases,
          rs10156191_interpretacion: item.rs10156191_interpretacion,
          rs1049742_resultado: item.rs1049742_resultado,
          rs1049742_bases: item.rs1049742_bases,
          rs1049742_interpretacion: item.rs1049742_interpretacion,
          rs1049793_resultado: item.rs1049793_resultado,
          rs1049793_bases: item.rs1049793_bases,
          rs1049793_interpretacion: item.rs1049793_interpretacion,
          Validado: 1, 
          NoMutacionesDetectadas: this.getMutationCount(item),
          Interpretacion: this.getInterpretation(item)
        };
        
        const response = await ServicioLaboratorioDAO.validacionQA(registroCompleto);
        if (response.data && response.data.result === 1) {
          // Set the UI state to validated only after successful API response
          item.Validado = true;
          this.$root.mensajeExito = 'Registro validado correctamente';
        } else {
          this.$root.mensajeError = 'Error: ' + response.data.message;
        }
      } catch (error) {
        this.$root.mensajeError = 'Error en la petición: ' + (error.response?.data?.message || error.message);
      }
    },

    puedeVisualizar(item) {
      return Boolean(
        item?.rs2052129_resultado ||
        item?.rs10156191_resultado ||
        item?.rs1049742_resultado ||
        item?.rs1049793_resultado
      );
    },

    async visualizarReporte(item) {
      try {
        const payload = {
          id: item.id,
          transaction_id: item.transaction_id,
          rs2052129_resultado: item.rs2052129_resultado,
          rs2052129_bases: item.rs2052129_bases,
          rs2052129_interpretacion: item.rs2052129_interpretacion,
          rs10156191_resultado: item.rs10156191_resultado,
          rs10156191_bases: item.rs10156191_bases,
          rs10156191_interpretacion: item.rs10156191_interpretacion,
          rs1049742_resultado: item.rs1049742_resultado,
          rs1049742_bases: item.rs1049742_bases,
          rs1049742_interpretacion: item.rs1049742_interpretacion,
          rs1049793_resultado: item.rs1049793_resultado,
          rs1049793_bases: item.rs1049793_bases,
          rs1049793_interpretacion: item.rs1049793_interpretacion,
          NoMutacionesDetectadas: this.getMutationCount(item),
          Interpretacion: this.getInterpretation(item),
          Validado: 0
        };

        const response = await ServicioLaboratorioDAO.preview(payload);

        if (response?.data?.result === 1) {
          let registros = [];
          const dataResponse = response.data?.data;

          if (Array.isArray(dataResponse)) {
            registros = dataResponse;
          } else if (typeof dataResponse === 'string' && dataResponse.trim().length) {
            try {
              registros = JSON.parse(dataResponse);
            } catch (parseError) {
              console.error('Error al parsear respuesta de preview:', parseError);
            }
          } else if (dataResponse?.Table0 && Array.isArray(dataResponse.Table0)) {
            registros = dataResponse.Table0;
          }

          const archivo = registros?.[0]?.ArchivoPDF;
          if (archivo) {
            const base = this.config?.RutaResultados || '';
            const separator = base.endsWith('/') ? '' : '/';
            const url = `${base}${separator}${archivo}`;
            window.open(url, '_blank');
            return;
          }
        }

        this.$root.mensajeError = 'No fue posible obtener la vista previa del reporte';
      } catch (error) {
        console.error('Error al obtener vista previa:', error);
        this.$root.mensajeError = 'Error al obtener la vista previa del reporte';
      }
    }
  }
};
</script>

<style scoped>
.v-data-table >>> th {
  background-color: #204871 !important;
  color: white !important;
}

.v-data-table >>> .subheader-row th {
  background-color: #336faa !important;
  color: white !important;
  border-right: 1px solid #e0e0e0;
}

/* Add borders for rs* group sections */
.v-data-table >>> th[colspan="3"] {
  /*border-left: 1px solid #e0e0e0;*/
  border-right: 1px solid #e0e0e0;
}

.v-data-table >>> tr td:nth-child(6),
.v-data-table >>> tr td:nth-child(7),
.v-data-table >>> tr td:nth-child(8),
.v-data-table >>> tr td:nth-child(9) {
  
  border-right: 1px solid #e0e0e0;
}

.v-data-table >>> tr td:nth-child(10),
.v-data-table >>> tr td:nth-child(11),
.v-data-table >>> tr td:nth-child(12) {
  border-right: 1px solid #e0e0e0;
}

.v-data-table >>> tr td:nth-child(13),
.v-data-table >>> tr td:nth-child(14),
.v-data-table >>> tr td:nth-child(15) {
  border-right: 1px solid #e0e0e0;
}

.v-data-table >>> tr td:nth-child(16),
.v-data-table >>> tr td:nth-child(17),
.v-data-table >>> tr td:nth-child(18) {
  border-right: 1px solid #e0e0e0;
}

.v-data-table >>> tr td:nth-child(19),
.v-data-table >>> tr td:nth-child(20) {
  border-right: 1px solid #e0e0e0;
}

.preview-icon {
  cursor: pointer;
}

.preview-icon--disabled {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}

</style>
